__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/fa9bfe7/_next/";